<template><div><h1>VUX V2.9.0 released</h1>
<h2><a href="/en/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] add event:on-after-show event:on-after-hide #2465</li>
</ul>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[fix] fix weui-loading style</li>
</ul>
<h2><a href="/en/components/confirm.html">Confirm</a></h2>
<ul><li>[fix] fix inputAttrs issue with no-default-value #2618</li>
<li>[fix] fix focus auto-blur issue #2610</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] support order-map to customize column orders #2300</li>
<li>[fix] fix mask cause body scroll in iOS #2593</li>
<li>[feature] add arg:value for event:on-confirm #2632</li>
<li>[fix] fire event:on-confirm after nextTick #2632</li>
<li>[feature] support format YYYY-MM-DD A #2627 @jack87918</li>
</ul>
<h2><a href="/en/components/inline-x-switch.html">InlineXSwitch</a></h2>
<ul><li>[feature] new component #2624</li>
</ul>
<h2><a href="/en/components/loading.html">Loading</a></h2>
<ul><li>[fix] add variable loading-z-index #2484</li>
<li>[enhance] support using empty text to hide loading text #2566</li>
</ul>
<h2><a href="/en/components/msg.html">Msg</a></h2>
<ul><li>[change] prop:buttons displays as slot:buttons default content</li>
</ul>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[enhance] show warning when picker value is not a string #2568</li>
</ul>
<h2><a href="/en/components/popover.html">Popover</a></h2>
<ul><li>[fix] fix position in fixed container #2590</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] add prop:disabled #2594</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[feature] support prop:should-rerender-on-show for forcing rerendering #2598</li>
<li>[feature] support prop:should-scroll-top-on-show for forcing scrolling top #2598</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[feature] add event:on-clear #2251</li>
</ul>
<h2><a href="/en/components/selector.html">Selector</a></h2>
<ul><li>[fix] avoid newer-version-vue select value issue #2633 #2587</li>
<li>[enhance] use v-html for title #2615</li>
</ul>
<h2><a href="/en/components/sticky.html">Sticky</a></h2>
<ul><li>[feature] add prop:disabled #2601</li>
<li>[enhance] add development tip if scroll-box doesnot exist</li>
</ul>
<h2><a href="/en/components/tab.html">Tab</a></h2>
<ul><li>[feature] support prop:bar-position</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] add prop:disabled #2641</li>
</ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul><li>[feature] support plain for warn-button #2478</li>
</ul>
<h2><a href="/en/components/x-circle.html">XCircle</a></h2>
<ul><li>[feature] support gradient #2616 @spencer1994</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] support variable dialog-gap-width #2640</li>
<li>[enhance] support dialog-width and dialog-max-width variable #2577</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[fix] fix wrong valid when value is empty string #2415</li>
<li>[fix] fix disabled style in iOS #2458</li>
<li>[change] show clear icon only when input gets focus #2567</li>
<li>[feature] add event:on-click-clear-icon #2603</li>
<li>[enhance] scroll input element into view when getting focus #2604</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.9.0 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.9.0-141.vue?eb2a44f4